import resolveConfig from '@modules/tailwindcss/resolveConfig';
import tailwindConfig from '@/tailwind.config.js';
import { isEditMode } from '@js/utils';

const win = window;

export default class HeaderElement {
  constructor(rootNode, props) {
    if (isEditMode()) {
      return;
    }

    this.backgroundCircle = rootNode.querySelector(
      '.background-circle-wrapper',
    );

    this.headline = rootNode.querySelector('.Headline');
    this.scrollNotice = rootNode.querySelector('.ScrollNotice');

    window.addEventListener(
      'scroll',
      this.scrollHandler.bind(this),
      { passive: true },
    );
    this.scrollHandler();
  }

  scrollHandler() {
    const fullConfig = resolveConfig(tailwindConfig);
    const breakpoints = fullConfig.theme.screens;

    const scalingRatio = win.innerWidth <= parseFloat(breakpoints.lg) ? 25 : 15;

    const ratio = win.scrollY / (win.innerHeight * 0.1);
    const scaling = 1 + scalingRatio * ratio;
    this.backgroundCircle.style.transform = `scale(${scaling})`;

    if (win.innerWidth > parseFloat(breakpoints.lg)) {
      this.headline.style.transform = `translate3d(0, ${win.scrollY * 0.35}px, 1px)`;
      this.scrollNotice.style.opacity = Math.max(0, 1 - (win.scrollY / 300));
    }
  }
}
